import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { getUserSettings } from '../service';

function useUserSettings() {
    return useQuery({
        queryKey: ['user-settings'],
        queryFn: () => getUserSettings(),
    });
}

function usePrefetchUserSettings() {
    const queryClient = useQueryClient();

    useEffect(() => {
        void queryClient.prefetchQuery({
            queryKey: ['user-settings'],
            queryFn: () => getUserSettings(),
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}

export { useUserSettings, usePrefetchUserSettings };
